import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-reject',
  templateUrl: './modal-reject.component.html',
  styleUrls: ['./modal-reject.component.css']
})
export class ModalRejectComponent {
  isApproved: boolean;
  observation: string = null;
  constructor(public dialogRef: MatDialogRef<ModalRejectComponent>,

              private spinner: NgxSpinnerService) { }

  closeModalReject(){
    this.dialogRef.close(true);
  }


}
